<template>
    <data-table
        action-button-text="کاربر جدید"
        action-button-icon="add"
        additional-action-button-text="وارد کردن گروهی کاربران سازمانی"
        additional-action-button-icon="icon-download"
        show-select
        remove-key="user"
        export-key="employees"
        settings-key="employees"
        @click:additionalActionButton="importDialog = true"
        @click:actionButton="router.push({path: '/employees/new' })"
        @getList="getList"
        @deleted="auth.fetchUser(true);system.setSystemDefaults(true);"
        :rowClick="(row) => router.resolve({path: `/employees/${row.id}`})"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :actions="actions"
        :getAllList="getAllList"
    >
        <template #actionButton v-if="!canCreateUser">
            <v-btn v-tooltip="'تعداد کاربران سازمانی به حداکثر مجاز خود رسیده است'" color="primary">
                <v-icon class="me-1" icon="add"></v-icon>کاربر جدید
            </v-btn>
        </template>
        <template #item.positions="{value}">
            <span v-if="value.length == 0">-------</span>
            <v-menu v-else>
                <template #activator="{ props }">
                    <v-btn v-if="value.length == 1" v-bind="props" variant="text" size="small" color="primary">{{value[0].department.name}}</v-btn>
                    <v-btn v-else v-bind="props" icon="icon-orgg" color="primary" variant="text"></v-btn>
                </template>
                <div class="py-3 px-3 bg-white elevation-1">
                    <div v-for="item in value" class="mb-2">
                        <p class="text-small text-secondary mb-2 font-weight-bold mt-1">دپارتمان {{item.department.name}}</p>
                        <div v-if="system.license.features.workingshift" class="mb-2">
                            <div class="d-flex align-center" v-for="inner in item.workingshifts">
                                <v-icon size="15" color="secondary" class="me-1" icon="icon-time-fast"></v-icon>
                                <p class="text-small">شیفت‌کاری: {{ inner.name }}</p>
                            </div>
                        </div>
                        <p class="text-small" v-if="item.default_reciever">گیرنده پیش‌فرض</p>
                    </div>
                </div>
            </v-menu>
        </template>
        <template #item.tickets_0="{value}">
            <v-chip color="error" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
        <template #item.tickets_1="{value}">
            <v-chip color="grey-darken-2" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
        <template #item.tickets_2="{value}">
            <v-chip color="secondary" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
        <template #item.tickets_3="{value}">
            <v-chip color="warning" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
        <template #item.tickets_4="{value}">
            <v-chip color="success" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
        <template #item.tickets_recipient="{value}">
            <v-chip color="secondary" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
        <template #item.tickets_owner="{value}">
            <v-chip color="success" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
    </data-table>
    <employee-leave-dialog v-model="leaveDialog" v-model:user="leaveUser"></employee-leave-dialog>
    <import-user-dialog v-model="importDialog" employee></import-user-dialog>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useAuthStore } from '@/stores/auth';
import { useSystemStore } from '@/stores/system';
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';

defineOptions({
    title: "کاربران",
    validate(context) {
        return context.auth.user.full_admin || context.auth.user.branch_admin || context.auth.user.department_admin;
    },
})
const api = useApi();
const router = useRouter();
const system = useSystemStore();
const auth = useAuthStore();
const loading = ref(false);
const roles = [{ name: 'مدیر ارشد', id: 'full_admin' }, { name: 'سرپرست شعبه', id: 'branch_admin' }, { name: 'سرپرست دپارتمان', id: 'department_admin' }, { name: 'کارشناس', id: 'employee' }];
const canCreateUser = ref(true);
const leaveDialog = ref(false);
const importDialog = ref(false);
const leaveUser = ref(false);
const items = ref([]);
const totalItems = ref(0);
const headers = ref([
    {
        title: '',
        key: 'newTab',
        minWidth: 25,
        filterable: false,
        sortable: false,
        exportable: false,
        removeable: false,
        hideInMobile: true,
    },
    {
        title: 'نام',
        key: 'first_name',
        value: (item) => item.first_name,
        minWidth: 140,
    },
    {
        title: 'نام خانوادگی',
        key: 'last_name',
        value: (item) => item.last_name,
        minWidth: 160,
    },
    {
        title: 'شعبه',
        key: 'branch',
        value: (item) => system.branches.find(x => x.id == item.branch_id).name,
        minWidth: 170,
        permission: auth.user.full_admin,
    },
    {
        title: 'دپارتمان ها',
        key: 'positions',
        exportValue: (item) => item.positions.map(x => `${x.department.name}${system.license.features.workingshift ? ` (${x.workingshifts.map((y) => y.name).join(", ")})` : ''}`).join(', '),
        minWidth: 170,
        filterable: false,
        sortable: false,
    },
    {
        title: 'نقش',
        key: 'role',
        value: (item) => item.full_admin ? 'مدیر ارشد' : item.branch_admin ? 'سرپرست شعبه' : item.positions.length && item.positions.some((x) => x.supervisor) ? 'سرپرست دپارتمان' : 'کارشناس',
        minWidth: 190,
    },
    {
        title: 'آمار تیکت ها',
        key: 'tickets',
        align: 'center',
        children: [
            {
                title: 'باز',
                key: 'tickets_0',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets[0] ?? '0'
            },
            {
                title: 'پاسخ کارشناس',
                key: 'tickets_2',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets[2] ?? '0'
            },
            {
                title: 'در حال انجام',
                key: 'tickets_1',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets[1] ?? '0'
            },
            {
                title: 'پاسخ مشتری',
                key: 'tickets_3',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets[3] ?? '0'
            },
            {
                title: 'بسته شده',
                key: 'tickets_4',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets[4] ?? '0'
            },
            {
                title: 'دریافتی',
                key: 'tickets_recipient',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets.recipient ?? '0'
            },
            {
                title: 'ارسالی',
                key: 'tickets_owner',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets.owner ?? '0'
            },
        ],
        filterable: false,
        sortable: false,
    },
    {
        title: 'میانگین رضایتمندی',
        key: 'satisfaction',
        value: (item) => item.satisfaction ? Math.ceil(item.satisfaction) + '%' : undefined,
        minWidth: 180,
        permission: system.license.features.satisfaction_reply,
    },
    {
        title: 'نام کاربری',
        key: 'username',
        value: (item) => item.email,
        minWidth: 120,
    },
    {
        title: 'ایمیل',
        key: 'email',
        value: (item) => item.email,
        minWidth: 120,
    },
    {
        title: 'شماره موبایل',
        key: 'mobile',
        value: (item) => item.mobile,
        minWidth: 120,
    },
    {
        title: 'وضعیت',
        key: 'status',
        value: (item) => item.status ? 'فعال' : 'غیر فعال',
        minWidth: 70,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
    keyword_based: { type: 'divider', label: 'بر اساس کلمه کلیدی', value: null },
    keyword: { type: 'text', label: 'نام یا نام خانوادگی', value: null },
    position_based: { type: 'divider', label: 'بر اساس جایگاه سازمانی', value: null },
    branches: { type: 'autocomplete', multiple: true, label: 'شعبه', items: system.branches, value: [], permission: auth.user.full_admin },
    departments: { type: 'autocomplete', multiple: true, label: 'دپارتمان', items:  [], value: [] },
    workingshifts: { type: 'autocomplete', multiple: true, label: 'شیفت های کاری', items: [], value: [], permission: system.license.features.workingshift },
    role: { type: 'autocomplete', label: 'نقش', items: roles, value: null },
    status_based: { type: 'divider', label: 'بر اساس وضعیت', value: null },
    status: { type: 'autocomplete', label: 'وضعیت', items: [{ name: 'فعال', id: '1' },{ name: 'غیرفعال', id: '0' }], value: null },
})
const actions = ref([
    {
        title: 'تماس با تلفن همراه',
        icon: 'icon-mobile',
        clicked: (selected) => window.location = 'tel:' + selected[0].mobile,
        enabled: (selected) => selected.length === 1 && selected[0].mobile
    },
    {
        title: 'تماس با تلفن ثابت',
        icon: 'icon-phone',
        clicked: (selected) => window.location = 'tel:' + selected[0].landline,
        enabled: (selected) => selected.length === 1 && selected[0].landline
    },
    {
        title: 'ثبت روز های مرخصی',
        icon: 'event_busy',
        clicked: (selected) => { leaveUser.value = selected[0]; leaveDialog.value = true },
        enabled: (selected) => selected.length === 1 && system.license.features.ticket_auto_assignment
    },
]);
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.userList({...finalFilters, employee: 1}).then(async res => {
        if (res && res.status == "OK") {
            items.value = res.data;
            totalItems.value = res.total;
            canCreateUser.value = res.canCreate;
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.userList({
            ...finalFilters,
            employee: 1,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == "OK") {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    return data;
}
onBeforeMount(async () => {
    system.setAdminDefaults().then(() => {
        filters.value.departments.items = system.departmentsAdmin
        filters.value.workingshifts.items = system.departmentsAdmin.map((x) => x.workingshifts).flat().filter((value, index, self) => self.findIndex(x=> x.id == value.id) >= index);
    });
});
</script>
